module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8503c5d7311a6bfd9f5e43d5a93ef84b.png";